import { FieldDescription } from '../shadcn/field';

// font-semibold restores label-large's 600, which the stock description's font-normal would otherwise beat.
export const Success = ({ children }: React.PropsWithChildren) => (
  <FieldDescription className="text-label-large font-semibold text-success-default">{children}</FieldDescription>
);
